import { render, staticRenderFns } from "./InstallSiwei.vue?vue&type=template&id=5af7940d&scoped=true&"
import script from "./InstallSiwei.vue?vue&type=script&lang=ts&"
export * from "./InstallSiwei.vue?vue&type=script&lang=ts&"
import style0 from "./InstallSiwei.vue?vue&type=style&index=0&id=5af7940d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af7940d",
  null
  
)

component.options.__file = "InstallSiwei.vue"
export default component.exports